import { useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { LoadingState } from '../components/ui/LoadingState';
import { treeHref } from '../utils/prettyArchiveLinks';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Legacy route: redirect to the in-tree Timeline tab (embedded view with full API support).
 */
const Timeline = () => {
  const { treeId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${API}/trees/${treeId}`);
        if (cancelled) return;
        const highlight = searchParams.get('highlight');
        const base = `${treeHref(res.data)}?tab=timeline`;
        navigate(highlight ? `${base}&highlight=${encodeURIComponent(highlight)}` : base, {
          replace: true,
        });
      } catch {
        if (!cancelled) {
          navigate(`/tree/${treeId}?tab=timeline`, { replace: true });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [treeId, navigate, searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <LoadingState message="Opening timeline…" />
    </div>
  );
};

export default Timeline;
